<template>
  <div class="app-modal-background">
    <div class="app-modal" :style="{ width: width }">
      <div class="app-modal-header">
        <div class="app-modal-title float-left" style="width:100% !important;">
          <slot name="title"></slot>
        </div>
<!--
        <div class="float-right"@click="closeModal()">
          <i
            class="fas fa-times fa-lg app-modal-close"
            title="Abbrechen"
          ></i>
        </div>
-->
        <div class="clearfix"></div>
      </div>
      <div class="app-modal-content"><slot name="content"></slot></div>
      <div class="app-modal-footer">
        <div class="app-modal-buttons-left float-left">
          <slot name="buttons-left"></slot>
        </div>
        <div class="app-modal-buttons-right float-right">
          <slot name="buttons-right"></slot>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppModal",
  props: {
    width: {
      type: String,
      default: "auto"
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
};
</script>
<style lang="scss" scoped>
.app-modal-background {
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  padding:5%;
}
.app-modal {
  background-color: #fefefe;
  margin: 5% auto;
  border-radius: 5px;
  margin-bottom: 15%;
}
.app-modal-header {
  padding: 8px 12px;
/*  border-bottom: 1px solid rgb(231, 234, 236); */
  color:#307bad;
}
.app-modal-title {
  font-weight: bold;
}
.app-modal-content {
  padding: 10px 12px;
}
.app-modal-content * {
  font-size: 11px;
}
.app-modal-footer {
  padding: 10px 12px;
}
.app-modal-buttons-right button {
  margin-left: 10px;
  min-width: 60px;
  font-size: 11px;
}
.app-modal-buttons-left button {
  margin-right: 10px;
}
.app-modal-close {
  cursor: pointer;
}
</style>
